"use client";
import SectionWrapper from "@cc/section-wrapper";
import { StaticImageData } from "next/image";
import { Stack, Typography } from "@mui/material";
import { MotionImage, MotionStack } from "@cc/motion-components";
import { useCallback, useMemo, useState } from "react";
import { H6_1 } from "@theme/components/typography.fontvariant";
import SwiperNavigationButton from "@cc/swiper-navigation-button";

export interface OurGuidingHandsProps {
  data: {
    title: string;
    slides: {
      image: string | StaticImageData;
      // years: string;
      title: string;
      description: string;
    }[];
  };
}

const OurGuidingHands = (props: OurGuidingHandsProps) => {
  const { data } = props;
  const { title, slides } = data;
  const [activeSlide, setActiveSlide] = useState(0);
  const slidesData = useMemo(() => {
    const firstSlide = slides[activeSlide];
    const previousSlides = slides.slice(0, activeSlide);
    const nextSlides = slides.slice(activeSlide + 1, slides.length);
    return [firstSlide, ...nextSlides, ...previousSlides];
  }, [activeSlide, slides]);

  const handlePrev = useCallback(() => {
    if (activeSlide === 0) {
      return setActiveSlide(slidesData.length - 1);
    } else {
      setActiveSlide((prev) => prev - 1);
    }
  }, [activeSlide, slidesData.length]);
  const handleNext = useCallback(() => {
    if (activeSlide === slidesData.length - 1) {
      return setActiveSlide(0);
    } else {
      setActiveSlide((prev) => prev + 1);
    }
  }, [activeSlide, slidesData.length]);

  return (
    <SectionWrapper
      color={"primary.main"}
      SectionHeaderProps={{
        title,
        TitleTypographyProps: {
          sx: {
            opacity: 0.9,
          },
        },
      }}
      rowGap={{ xs: 4, sm_md: 3 }}
      overflow={"hidden"}
    >
      <Stack columnGap={3} direction={"row"}>
        <MotionStack
          // key={slidesData[0].title}
          direction={{ xs: "column", sm_md: "row" }}
          flexShrink={0}
          width={{ xs: 1, sm_md: "fit-content" }}
          // sx={{ transition: "all 1s" }}
        >
          <MotionImage
            key={slidesData[0].title}
            src={slidesData[0].image}
            alt={slidesData[0].title}
            layout={"position"}
            sx={{
              width: { xs: "100%", sm_md: 312 },
              height: { xs: "auto", sm_md: "100%" },
              maxHeight: { xs: 267, sm: 398 },
              objectFit: "cover",
              objectPosition: "top",
            }}
          />
          {/* <MotionBox overflow={"hidden"} {...boxTransition}> */}
          <MotionStack
            px={3}
            py={{ xs: 3, sm_md: 5 }}
            bgcolor={"common.white"}
            spacing={2}
            width={{ xs: 1, sm_md: 332 }}
            // height={1}
          >
            {/* <Typography
                variant={"caption"}
                bgcolor={"secondary.400"}
                width={"fit-content"}
                p={0.75}
              >
                {/* {slidesData[0].years} */}
            {/* </Typography> */}
            <Typography component={"h3"} fontSize={H6_1}>
              {slidesData[0].title}
            </Typography>
            <Typography variant={"subtitle2"} textAlign={"justify"} component={"p"}>
              {slidesData[0].description}
            </Typography>
          </MotionStack>
          {/* </MotionBox> */}
        </MotionStack>
        {slidesData.slice(1, slidesData.length).map((item, index) => {
          const { image, title } = item;
          return (
            <MotionImage
              key={`${title}-${index}`}
              src={image}
              alt={title}
              sx={{
                width: { xs: "100%", sm_md: 312 },
                minWidth: { xs: 1, sm_md: 312 },
                height: { xs: "auto", sm_md: 398 },
                maxHeight: { xs: 267, sm: 398 },
                objectFit: "cover",
                objectPosition: "top",
              }}
            />
          );
        })}
      </Stack>
      <SwiperNavigationButton
        PrevButtonProps={{
          onClick: handlePrev,
        }}
        NextButtonProps={{
          onClick: handleNext,
        }}
        ml={"auto"}
        mr={{ xs: "auto", sm: "unset" }}
      />
      {/* <EnhancedSwiper
        data={slides}
        SlideComponent={GuidingSlides}
        slidesPerView={"auto"}
        spaceBetween={24}
        loop
        SlideWrapperProps={{
          sx: {
            width: 644,
            // mr: { xs: 0, md: "30px" },
          },
        }}
        navigation={{
          nextEl: ".swiper-guiding-next",
          prevEl: ".swiper-guiding-prev",
        }}
        sx={{
          overflow: { xs: "visible", md: "hidden" },
          // ".swiper-slide:not(.swiper-slide-active,.swiper-slide-next,.swiper-slide-prev)":
          //   {
          //     // width: 312,
          //     ml: "-333px",
          //   },
          // ".swiper-slide": {
          //   // width: 312,
          //   ".MuiBox-root": {
          //     width: 0,
          //     transition: "all .3s ease-out",
          //   },
          // },
          // ".swiper-slide-active": {
          //   // width: 644,
          //   ".MuiBox-root": {
          //     width: { xs: 1, md: 332 },
          //     transform: "scale(1)",
          //   },
          // },
          ".swiper-slide": {
            // width: 312,
            ".MuiBox-root": {
              width: 0,
              transition: "all .3s ease-out",
            },
          },
          ".swiper-slide-active": {
            width: 644,
            ".MuiBox-root": {
              width: { xs: 1, md: 332 },
              transform: "scale(1)",
            },
          },
        }}
        modules={[Navigation]}
        Slots={{
          ContainerEndChildren: (
            <SwiperNavigationButton
              PrevButtonProps={{
                className: "swiper-guiding-prev",
              }}
              NextButtonProps={{
                className: "swiper-guiding-next",
              }}
              ml={"auto"}
              mr={{ xs: "auto", sm: "unset" }}
              mt={{ xs: 4, sm_md: 3 }}
            />
          ),
        }}
      /> */}
    </SectionWrapper>
  );
};

export default OurGuidingHands;

// type GuidingSlideProps = {
//   image: string | StaticImageData;
//   // years: string;
//   title: string;
//   description: string;
// };

// const GuidingSlides = (props: GuidingSlideProps) => {
//   const { image, description, title } = props;
//   return (
//     <MotionStack
//       direction={{ xs: "column", sm_md: "row" }}
//       flexShrink={0}
//       width={{ xs: 1, sm_md: "fit-content" }}
//       // sx={{ transition: "all 1s" }}
//     >
//       <MotionImage
//         key={title}
//         src={image}
//         alt={title}
//         layout={"position"}
//         sx={{
//           width: { xs: "100%", sm_md: 312 },
//           height: { xs: "auto", sm_md: "100%" },
//           maxHeight: { xs: 267, sm: 398 },
//           objectFit: "cover",
//           objectPosition: "top",
//         }}
//       />
//       <MotionBox width={1} maxWidth={{ xs: 1, sm_md: 332 }} overflow={"hidden"}>
//         <MotionStack
//           px={3}
//           py={{ xs: 3, sm_md: 5 }}
//           bgcolor={"common.white"}
//           spacing={2}
//           width={{ xs: 1, sm_md: 332 }}
//           height={1}
//         >
//           <Typography component={"h3"} fontSize={H6_1}>
//             {title}
//           </Typography>
//           <Typography variant={"subtitle2"} component={"p"}>
//             {description}
//           </Typography>
//         </MotionStack>
//       </MotionBox>
//     </MotionStack>
//   );
// };
